import { Truck01, PackagePlus, MarkerPin04, LayersThree02 } from '@untitled-ui/icons-react/build/cjs';
import { TFunction } from 'i18next';

import { IStepNew, QuoteKeysType } from './createQuote.interface';

export const QUOTE_KEYS: Record<string, QuoteKeysType> = {
    QUOTE_DETAILS: 'quote_details',
    SHIPPER_CONSIGNEE_DETAILS: 'shipper_consignee_details',
    DIMENSIONS: 'dimensions',
    SHIPMENT_DETAILS: 'shipment_details',
};

export const QUOTE_STEPS_KEYS = [QUOTE_KEYS.QUOTE_DETAILS, QUOTE_KEYS.SHIPPER_CONSIGNEE_DETAILS, QUOTE_KEYS.DIMENSIONS];

export const QUOTE_STEPS = (t: TFunction<'en', undefined>, classification?: string): IStepNew[] => {
    const baseSteps: IStepNew[] = [
        {
            step: 1,
            key: QUOTE_KEYS.QUOTE_DETAILS,
            title: t('QuotingHub.QuotingDashboard.Add_Quote_Details'),
            icon: PackagePlus,
            screenTitle: 'Add Quote Details',
            screenDescription: 'Set up the basic details for your quote',
        },
        {
            step: 2,
            key: QUOTE_KEYS.SHIPPER_CONSIGNEE_DETAILS,
            title: 'Shipper & Consignee',
            icon: MarkerPin04,
            screenTitle: 'Add Shipper and Consignee Details',
            screenDescription: 'Enter the address information for both shipper and consignee',
        },
    ];

    if (classification === 'ftl') {
        return [
            ...baseSteps,
            {
                step: 3,
                key: QUOTE_KEYS.SHIPMENT_DETAILS,
                title: 'Load & Shipment Details',
                icon: Truck01,
                screenTitle: 'Load & Shipment Details',
                screenDescription: 'Add load overview, equipment type, services, and insurance',
            },
        ];
    }

    return [
        ...baseSteps,
        {
            step: 3,
            key: QUOTE_KEYS.SHIPMENT_DETAILS,
            title: 'Set Shipment Details',
            icon: Truck01,
            screenTitle: 'Set Shipment Details',
            screenDescription: 'Add essential shipment information for processing',
        },
        {
            step: 4,
            key: QUOTE_KEYS.DIMENSIONS,
            title: 'Add Load Details',
            icon: LayersThree02,
            screenTitle: 'Dimensions & Visualizations',
            screenDescription: 'Provide package dimensions to calculate volume and weight',
        },
    ];
};
